import { render, staticRenderFns } from "./AuthView.vue?vue&type=template&id=cd52c4ee&scoped=true&"
import script from "./AuthView.vue?vue&type=script&lang=js&"
export * from "./AuthView.vue?vue&type=script&lang=js&"
import style0 from "./AuthView.vue?vue&type=style&index=0&id=cd52c4ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd52c4ee",
  null
  
)

export default component.exports